import {
    Box,
    Heading,
    VStack,
    Text,
    Card,
    CardBody,
    Button,
    Link,
    Icon,
    HStack,
    Flex
} from '@chakra-ui/react';
import { FaCalendarAlt, FaCog } from 'react-icons/fa';
import { Link as RouterLink } from 'react-router-dom';
import ContactSupport from '../components/ContactSupport';

const AccountCreated = () => {
    return (
        <Box maxW="600px" mx="auto" p={6}>
            <VStack spacing={8} align="stretch">
                {/* Welcome Header */}
                <Box textAlign="center">
                    <Heading size="xl" mb={4} color="#0071E3">
                        Welcome to Yaxle
                    </Heading>
                    <Text fontSize="lg" color="gray.600">
                        Hey let's get you set up!
                    </Text>
                </Box>

                {/* Setup Steps */}
                <VStack spacing={6} align="stretch">
                    {/* Step 1 - Schedule Setup */}
                    <Card>
                        <CardBody>
                            <HStack spacing={4} align="start">
                                <Flex
                                    minW="40px"
                                    h="40px"
                                    bg="#0071E3"
                                    color="white"
                                    borderRadius="full"
                                    align="center"
                                    justify="center"
                                    fontWeight="bold"
                                    fontSize="lg"
                                >
                                    1
                                </Flex>
                                <VStack align="start" spacing={3} flex={1}>
                                    <Text fontSize="lg" fontWeight="semibold">
                                        Schedule some time with us to get you set up!
                                    </Text>
                                    <Text color="gray.600">
                                        Book a quick setup call with the team to help you get the most out of Yaxle.
                                    </Text>
                                    <Link
                                        href="https://cal.com/partbay/basicsetup"
                                        isExternal
                                        _hover={{ textDecoration: 'none' }}
                                    >
                                        <Button
                                            colorScheme="gray"
                                            leftIcon={<Icon as={FaCalendarAlt as React.ElementType} />}
                                            size="md"
                                        >
                                            Schedule Setup Call
                                        </Button>
                                    </Link>
                                </VStack>
                            </HStack>
                        </CardBody>
                    </Card>

                    {/* Step 2 - Start Free Trial */}
                    <Card>
                        <CardBody>
                            <HStack spacing={4} align="start">
                                <Flex
                                    minW="40px"
                                    h="40px"
                                    bg="#0071E3"
                                    color="white"
                                    borderRadius="full"
                                    align="center"
                                    justify="center"
                                    fontWeight="bold"
                                    fontSize="lg"
                                >
                                    2
                                </Flex>
                                <VStack align="start" spacing={3} flex={1}>
                                    <Text fontSize="lg" fontWeight="semibold">
                                        Make sure you or your organization has started 14 day free trial
                                    </Text>
                                    <Text color="gray.600">
                                        Access your settings to manage your subscription and start your free trial.
                                    </Text>
                                    <Link
                                        as={RouterLink}
                                        to="/settings"
                                        _hover={{ textDecoration: 'none' }}
                                    >
                                        <Button
                                            colorScheme="gray"
                                            leftIcon={<Icon as={FaCog as React.ElementType} />}
                                            size="md"
                                        >
                                            Go to Settings
                                        </Button>
                                    </Link>
                                </VStack>
                            </HStack>
                        </CardBody>
                    </Card>
                </VStack>

                <ContactSupport variant="minimal" />
            </VStack>
        </Box>
    );
};

export default AccountCreated;
